export default __webpack_public_path__ + "static/media/curbPassLogoWhite.b081ff35.svg";